import * as C from "@components";
import css from "./announcement-seedling-section.module.scss";
import VadImage from "vadimages-nextjs-image-optimizer";
import * as Api from '@api';

export const AnnouncementSeedlingSectionKeys = [
    "announcement.badge",
    "announcement.title",
    "announcement.body",
    "announcement.btn",
] as const;

export type AnnouncementSeedlingSectionProps = {
    pageContent: Api.Content<typeof AnnouncementSeedlingSectionKeys[number]>;
};

const TextSection = ({ content }: { content: Api.Content<string> }) => (
    <div className={css["text-section"]}>
        <div className={css["badge-new"]}>{content["announcement.badge"]?.data}</div>
        <div className={css["title"]}>{content["announcement.title"]?.data}</div>
        <div className={css["text"]}>{content["announcement.body"]?.data}</div>
        <C.PageLink href="/products/all-in-ones/active-seedling" variant={C.PageLinkVariant.Button}>
            {content["announcement.btn"]?.data}
        </C.PageLink>
    </div>
);

const MobileTextSection = ({ content }: { content: Api.Content<string> }) => (
    <div className={css["text-section"]}>
        <div>
            <div className={css['badge-new']}>{content['announcement.badge']?.data}</div>
            <div className={css['title']}>{content['announcement.title']?.data}</div>
            <div className={css['text']}>{content['announcement.body']?.data}</div>
        </div>
        <C.PageLink href="/products/all-in-ones/active-seedling" variant={C.PageLinkVariant.Button}>
            {content["announcement.btn"]?.data}
        </C.PageLink>
    </div>
);

const SeedlingAnnouncementSection = ({ pageContent }: AnnouncementSeedlingSectionProps) => (
    <C.PageSection>
        <div className={css["image"]}>
            <TextSection content={pageContent} />
            <VadImage src={"/images/announcement/seedling-promo.png"} width="800" height="300" alt="Seedling Promo" />
        </div>

        <div className={css["image-mobile"]}>
            <MobileTextSection content={pageContent} />
            <VadImage src={"/images/announcement/m-seedling-promo.png"} width="327" height="549" alt="Seedling Promo Mobile" />
        </div>
    </C.PageSection>
);

export default SeedlingAnnouncementSection;
